import PropTypes from 'prop-types'
import React from 'react'

import ReserveBonus from 'components/ReserveBonus/ReserveBonus.jsx'
import Reserve from 'components/Reserve/Reserve.jsx'

import { MAX_BUILDING_LEVEL } from 'constants'

import styles from './ReserveSelectItem.scss'
import cx from 'classnames'
import { RESERVE_DELAYED, RESERVE_IN_PROGRESS } from './constants'
import { getEndDateMessage } from 'helpers/datetime'
import moment from 'moment/moment'

const ReserveSelectItem = (props) => {
    const nextLevel = (props.level < MAX_BUILDING_LEVEL ? props.level + 1 : props.level)

    return (
        <div className={styles.base}>
            <div className={styles.reserveWrapper}>
                <div className={styles.reserve}>
                    <Reserve
                        type={props.reserveInfo.type}
                        level={props.highlighted ? nextLevel : props.level}
                        reserves={props.reserves}
                        highlighted={props.highlighted}
                        playSound={props.playSound || null}
                    />
                </div>
                <div className={styles.content}>
                    <ReserveBonus
                        reserveInfo={props.reserveInfo}
                        level={props.level}
                        nextLevel={nextLevel}
                        isNextLevelHighlighted={props.highlighted}
                        layoutType='tooltip'
                    />
                </div>
                {props.children}
            </div>
            {props.reservesQueueInfo && (
                <React.Fragment>
                    <div className={styles.divider}/>
                    {props.reservesQueueInfo.order === 0 ? (
                        <div className={cx(styles.status, styles.status__inProgress)}>
                            {RESERVE_IN_PROGRESS(
                                getEndDateMessage(moment(props.reservesQueueInfo.productionEnds))
                            )}
                        </div>
                    ) : (
                        <div className={styles.status}>
                            {RESERVE_DELAYED(
                                <span className={styles.highlighted}>
                                    {props.reservesQueueInfo.order}
                                </span>,
                                <span className={styles.highlighted}>
                                    {getEndDateMessage(moment(props.reservesQueueInfo.productionEnds))}
                                </span>
                            )}
                        </div>
                    )}
                </React.Fragment>
            )}
        </div>
    )
}

ReserveSelectItem.propTypes = {
    reserveInfo: PropTypes.object.isRequired,
    level: PropTypes.number.isRequired,
    reserves: PropTypes.arrayOf(PropTypes.object).isRequired,
    highlighted: PropTypes.bool.isRequired,
    children: PropTypes.node,
    reservesQueueInfo: PropTypes.object,
    playSound: PropTypes.func,
}

export default ReserveSelectItem



// WEBPACK FOOTER //
// ./containers/BuildingCard/components/ReserveSelect/components/ReserveSelectItem/ReserveSelectItem.jsx